import { render, staticRenderFns } from "./user-center.vue?vue&type=template&id=5568a7f0&scoped=true"
import script from "./user-center.vue?vue&type=script&lang=js"
export * from "./user-center.vue?vue&type=script&lang=js"
import style0 from "./user-center.vue?vue&type=style&index=0&id=5568a7f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5568a7f0",
  null
  
)

export default component.exports